import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const AuthCtx = createContext(null);
const API = process.env.REACT_APP_BACKEND_URL;

const client = axios.create({ baseURL: API });

// attach token if present
client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('px_admin_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [ready, setReady] = useState(false);

  const bootstrap = useCallback(async () => {
    const t = localStorage.getItem('px_admin_token');
    if (!t) {
      setReady(true);
      return;
    }
    try {
      const { data } = await client.get('/api/auth/me');
      setAdmin(data);
    } catch (e) {
      localStorage.removeItem('px_admin_token');
    }
    setReady(true);
  }, []);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  const login = async (email, password) => {
    const { data } = await client.post('/api/auth/login', { email, password });
    localStorage.setItem('px_admin_token', data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const logout = () => {
    localStorage.removeItem('px_admin_token');
    setAdmin(null);
  };

  return (
    <AuthCtx.Provider value={{ admin, ready, login, logout, client }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export { client };
